import { useQuery } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

/**
 * Fetches the system health snapshot from GET /api/admin/health.
 * The endpoint returns 503 when the overall status is "down"; we accept that
 * status code so the UI can still render the per-service report instead of
 * erroring out.
 */
export const useSystemHealth = () => {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery(
    "systemHealth",
    async () => {
      const token = await getAccessTokenSilently();
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/admin/health`,
        {
          headers: { Authorization: `Bearer ${token}` },
          validateStatus: (status) =>
            (status >= 200 && status < 300) || status === 503,
        },
      );
      return data.data; // { status, services, timestamp }
    },
    {
      refetchInterval: 30000, // keep the dashboard reasonably fresh
      staleTime: 15000,
      refetchOnWindowFocus: true,
    },
  );
};
